import { render, staticRenderFns } from "./ReportCard.vue?vue&type=template&id=66a2f17a"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"
import style0 from "./ReportCard.vue?vue&type=style&index=0&id=66a2f17a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports